import { HttpClient } from '@angular/common/http'
import { TranslateLoader } from '@ngx-translate/core'
import { Observable, forkJoin, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

export interface TranslationResource {
  prefix: string
  suffix: string
}

/**
 * Loads and merges per-locale JSON catalogs from multiple sources
 * (app catalog + lib-core catalog), shallow-merged into a single dictionary.
 *
 * IMPORTANT: this must be built with a clean HttpClient (from HttpBackend), not
 * the app's CustomHttp — CustomHttp prepends the API base URL and would break
 * loading of local /assets files.
 */
export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly resources: TranslationResource[],
  ) { }

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    const requests = this.resources.map((resource) =>
      this.http
        .get<Record<string, unknown>>(`${resource.prefix}${lang}${resource.suffix}`)
        .pipe(catchError(() => of({}))),
    )
    return forkJoin(requests).pipe(
      map((parts) => parts.reduce((acc, part) => ({ ...acc, ...part }), {})),
    )
  }
}
